import { Markdown, Mention, Plugin } from 'ckeditor5';
import { CUSTOM_MENTIONS_CONFIG_KEY } from '.';
export class CustomMentionsEditing extends Plugin {
    static get pluginName() {
        return 'CustomMentionsEditing';
    }
    static get requires() {
        return [Mention, Markdown];
    }
    constructor(editor) {
        super(editor);
        const config = editor.config.get(CUSTOM_MENTIONS_CONFIG_KEY);
        this.mentionTypes = (config === null || config === void 0 ? void 0 : config.types) || ['user', 'team', 'contact'];
    }
    init() {
        const { editor, mentionTypes } = this;
        const mentionPlugin = editor.plugins.get('Mention');
        const hrefRegexp = new RegExp(`^(${mentionTypes.join('|')}):`);
        // Markdown Link -> Model
        editor.conversion.for('upcast').elementToAttribute({
            view: {
                name: 'a',
                attributes: {
                    // By converting to and from a anchor field, the markdown plugin just works
                    href: hrefRegexp,
                },
            },
            model: {
                key: 'mention',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                value: (viewItem) => {
                    const href = decodeURIComponent(viewItem.getAttribute('href'));
                    const [type, id] = href.split(':'); // Split "user:auth0|123"
                    // Reconstruct the unique ID to match the Feed format: "@user:auth0|123"
                    // The marker ('@') is required by CKEditor's internal logic.
                    const uniqueId = `@${type}:${id}`;
                    // Convert to a native mention attribute, with some extra attributes we can use when outputting to markdown
                    return mentionPlugin.toMentionAttribute(viewItem, {
                        link: href,
                        userId: id,
                        id: uniqueId, // Uniqueness guaranteed
                    });
                },
            },
            converterPriority: 'high',
        });
        // Model -> View/Output
        editor.conversion.for('downcast').attributeToElement({
            model: 'mention',
            view: (mention, { writer }) => {
                if (!mention) {
                    return undefined;
                }
                const [type, id] = mention.link.split(':'); // => ['user', 'auth0|123']
                // By converting to and from a anchor field, the markdown plugin just works
                return writer.createAttributeElement('a', {
                    class: 'custom-mention-pill',
                    href: `${type}:${id}`,
                }, {
                    priority: 20,
                    id: mention.id,
                });
            },
            converterPriority: 'high',
        });
    }
}
